import CupomModel from "../models/cupomModel";
import nfetch from "../utils/events/nfetch";

import { IService } from "./base/iService";

export default class CupomService extends IService<CupomModel> {
    constructor() {
        super("Cupom");
    }

    public listByFranquiaId(franquiaId: number) {
        return nfetch(`/Cupom/ListByFranquiaId?franquiaId=${franquiaId}`, {
            credentials: "same-origin",
        });
    }
}
